import React, { useEffect, useMemo, useState } from "react"
import { COLUMNS1, COLUMNS3, COLUMNS4 } from "./PatientColumns"
import Table from "../../../components/Table"
import { useSelector } from "react-redux"
import {
  getPatientDetail,
  getallPatientDetail, uploadSpecificFile,
  updateAppointment,
  getAppointmentsByQuery,
  getLatestAppointmentDetails,
  getAppointmentsByPagination,
  getAppointmentById,
  getManageStaffDetailsById,
  getAllCenters
} from "../../../core/services/api"
import "./PatientDirectory.scss"
import { useHistory, useLocation } from "react-router"
import Button from "../../../components/Button"
import ViewTransferPatient from "../../CenterAdmin/ViewTransferPatient/ViewTransferPatient"
import { MocUserRole } from "../../../core/services/models/Enums"
import Forms from "../../../components/PatientDiagnosisDrawer/components/forms/Forms"
import { IPatient } from "../../../core/services/models/Patient"
import moment from "moment"
import Toast from "../../../components/Toast"
import { PatientDetailStyles } from "resources/styles/pages/PatientDetailStyles"
import { useTheme } from "@emotion/react"
import { styles } from "resources/styles/Styles"
import Select from "react-select"
import { calculateAge } from "core/utils/date"

function PatientDirectory(props: any) {
  const { selectedCenter } = props
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const readOnlys = useSelector((state: any) => state?.user?.readOnly)
  const location = useLocation()
  const COLUMNS2 = [
    {
      Header: "Appointment Date",
      accessor: (d: any) => {
        return d.scheduleDate
          ? moment(d.scheduleDate).local().format("DD-MM-YYYY")
          : ""
      },
    },
    {
      Header: "Appointment Time",
      accessor: (d: any) => {
        let appointmentTimeStr = ""
        if (d?.appointmentType === "HC") {
          appointmentTimeStr = d?.slots?.length > 1 ? `${d?.slots[0]}-${d?.slots[d?.slots?.length - 1]}` : d?.slots?.length === 1 ? `${d?.slots[0]}` : ""
        } else if (d?.appointmentType === "IPD") {
          appointmentTimeStr = d?.allottedBed?.slots?.length > 1 ? `${d?.allottedBed?.slots[0]}-${d?.allottedBed?.slots[d?.allottedBed?.slots?.length - 1]}` : d?.allottedBed?.slots?.length === 1 ? `${d?.allottedBed?.slots[0]}` : ""
        }
        return appointmentTimeStr
      },
    },
    {
      Header: "Appointment Type",
      accessor: "appointmentType",
    },
    {
      Header: "Patient ID",
      accessor: "mocId",
    },
    {
      Header: "Patient Name",
      accessor: "patientName",
    },
    {
      Header: "Center",
      accessor: "centerName",
    },
    {
      Header: "Completeness Status",
      accessor: "documentCompleteStatus",
      Cell: (props: any) => {
        const flag = props.value
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column"
            }}>
            <div style={{
              display: "flex",
              flexDirection: "row",
              padding: "0 10px",
            }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "50%",
                  border: "1px solid black",
                  width: "20px",
                  height: "20px",
                  backgroundColor: `${flag === "PENDING" ? "yellow" : "white"}`
                }}
              >
              </div>
              <p
                style={{
                  padding: "0px 5px"
                }}
              >Pending</p>
            </div>
            <div style={{
              display: "flex",
              flexDirection: "row",
              padding: "0 10px"
            }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "50%",
                  border: "1px solid black",
                  width: "20px",
                  height: "20px",
                  backgroundColor: `${flag === "APPROVED" ? "green" : "white"}`
                }}
              >
              </div>
              <p
                style={{
                  padding: "0px 5px"
                }}
              >Approved</p>
            </div>
            <div style={{
              display: "flex",
              flexDirection: "row",
              padding: "0 10px"
            }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "50%",
                  border: "1px solid black",
                  width: "20px",
                  height: "20px",
                  backgroundColor: `${flag === "REJECTED" ? "red" : "white"}`
                }}
              >
              </div>
              <p
                style={{
                  padding: "0px 5px"
                }}
              >Rejected</p>
            </div>
          </div>
        )
      },
    },
    {
      Header: "Upload",
      accessor: "upload",
      Cell: (props: any) => {
        const rowIDValue = props?.row?.original?.id
        return (
          <>
            <label
              htmlFor={`${rowIDValue}`}
              className={`mrd-file-upload`}
            >
              <div>Upload</div>
            </label>
            <input
              id={`${rowIDValue}`}
              type="file"
              style={{ display: "none" }}
              onChange={(e) => {
                uploadHandler(e, props)
              }}
              // value={files}
              multiple
            />
          </>
        )
      },
    },
  ]
  const theme = useTheme()
  const globalStyles = styles(theme)
  const classes = PatientDetailStyles(theme)

  const [viewTransferPatient, setViewTransferPatient] = useState<any>(false)
  const [patientId, setPatientId] = useState<any>()
  const [rowPatientId, setrowPatientId] = useState("")
  const [appointmentId, setAppointmentId] = useState("")
  const [show, setShow] = useState(false)
  const [patientDetail, updatePatientDetail] = React.useState<IPatient>()
  const [isUploaded, setIsUploaded] = useState<boolean>(false)
  const [isUploadError, setIsUploadError] = useState<boolean>(false)
  const [fileSizeError, setFileSizeError] = useState<boolean>(false)
  const [isApproved, setIsApproved] = useState<boolean>(false)
  const [isRejected, setIsRejected] = useState<boolean>(false)
  const [noAppointmentsError, setNoAppointmentsError] = useState<boolean>(false)

  const columns = useMemo(() => {
    let cols: any
    if (userRole === MocUserRole.MRD && location?.pathname === "/patientList") {
      cols = COLUMNS3
    } else if (userRole === MocUserRole.MRD && location?.pathname === "/mrd") {
      cols = COLUMNS2
    } else if (userRole !== MocUserRole.MRD) {
      if (
        userRole !== MocUserRole.GENETIC_COUNSELLOR &&
        userRole !== MocUserRole.PSYCHOLOGIST &&
        userRole !== MocUserRole.CONSULTANT
      ) {
        if ([
          MocUserRole.SYSTEM_ADMIN,
          MocUserRole.OPERATIONS
        ].includes(userRole)) {
          cols = COLUMNS1
        } else {
          let tempCols = [...COLUMNS4]
          let index = tempCols?.findIndex((each) => each?.Header === "Center")
          tempCols?.splice(index, 1)
          cols = tempCols
        }
      } else {
        cols = COLUMNS4
      }
    } else {
      cols = COLUMNS2
    }

    let transferPatCol = cols.find((each: any) => each?.accessor === "transfer patient");
    if (
      [MocUserRole.SYSTEM_ADMIN, MocUserRole.OPERATIONS].includes(userRole) &&
      (!transferPatCol || Object.keys(transferPatCol).length === 0)
    ) {
      cols.push(
        {
          Header: "",
          accessor: "transfer patient",
          Cell: (props: any) => {
            if (props?.row?.original?.survivalStatus === "Alive") {
              return (
                <div>
                  <Button
                    text="Transfer"
                    outline={true}
                    onClick={() => setViewTransferPatient(!viewTransferPatient)}
                    id="transfer"
                    disabled={readOnlys}
                  />
                </div>
              )
            } else {
              return (
                <div></div>
              )
            }
          }
        },
      )
    }
    return cols
  }, [userRole, location])

  const [data, setData] = useState<any>([])
  const [pastAppointments, updatePastAppointments] = useState<any>([])
  const [accordion, updateAccordion] = React.useState<any | null>()

  const history = useHistory()
  const pathName = props?.location?.pathname || history?.location?.pathname

  //Pagination
  const [pages, setPages] = useState<any>(0)
  const [currPage, setCurrPage] = useState<any>(0)
  const [pageSize, setPageSize] = useState<any>(10)
  const [totalPatientsCount, setTotalPatientsCount] = useState<any>("")
  //Search For Patient Directory
  const [searchText, setSearchText] = useState<any>("")
  const [appointmentDetails, setAppointmentDetails] = useState<any>({})
  const [staffDetails, setStaffDetails] = useState<any>({})
  const centerID = location?.state?.centerId
  const [centerOptions, setCenterOptions] = useState<any>([])
  const [centerFilter, setCenterFilter] = useState<any>(centerID ? centerID : "")


  useEffect(() => {
    getAllCenters()
      .then((res: any) => {
        const tempCenters: any = res?.map((each: any) => {
          return { label: each?.centerName, value: each?.id }
        })
        setCenterOptions(tempCenters)
      })
      .catch((err: any) => console.log(err?.message))
  }, [])

  useEffect(() => {
    if (userRole === MocUserRole.MRD && location?.pathname === "/patientList") {
      let url = ""
      if (searchText) {
        url = `?page=${currPage}&pageSize=${pageSize}&sortBy=createdAt&searchText=${searchText}`
      } else {
        url = `?page=${currPage}&pageSize=${pageSize}&sortBy=createdAt`
      }
      getallPatientDetail(url)
        .then((res) => {
          const { data, totalPages, totalElements } = res
          console.log(totalElements)
          setPages(totalPages)
          setTotalPatientsCount(totalElements)
          const response = data.filter(
            (each: any) => !each?.isDeleted || each?.isDeleted === false
          )
          setData(response)
        })
        .catch((err) => {
          console.log("err", err)
        })
    } else if (userRole !== MocUserRole.MRD) {
      let url = ""
      if ([
        MocUserRole.SYSTEM_ADMIN,
        MocUserRole.OPERATIONS,
      ].includes(userRole)) {
        if (searchText && centerFilter) {
          url = `?page=${currPage}&pageSize=${pageSize}&sortBy=createdAt&searchText=${searchText}&centerId=${centerFilter}`
        } else if (searchText) {
          url = `?page=${currPage}&pageSize=${pageSize}&sortBy=createdAt&searchText=${searchText}`
        } else if (centerFilter) {
          url = `?page=${currPage}&pageSize=${pageSize}&sortBy=createdAt&centerId=${centerFilter}`
        } else {
          url = `?page=${currPage}&pageSize=${pageSize}&sortBy=createdAt`
        }
      } else if (searchText) {
        url = `?page=${currPage}&pageSize=${pageSize}&centerId=${userDetail?.currentCenter?.centerId}&sortBy=createdAt&searchText=${searchText}`
      } else {
        url = `?page=${currPage}&pageSize=${pageSize}&centerId=${userDetail?.currentCenter?.centerId}&sortBy=createdAt`
      }
      getallPatientDetail(url)
        .then((res) => {
          const { data, totalPages, totalElements } = res
          setPages(totalPages)
          setTotalPatientsCount(totalElements)
          const response = data?.filter(
            (each: any) => !each?.isDeleted || each?.isDeleted === false
          )
          if (response?.length > 0) {
            setData(response)
          } else {
            setData([])
          }
        })
        .catch((err) => {
          console.log("err", err)
        })
    } else {
      let url = `page=${currPage}&pageSize=${pageSize}&status=COMPLETED&sortBy=scheduleDate&sortDirection=DESC`
      if (searchText) {
        url += `&searchText=${searchText}`
      }
      if (selectedCenter) {
        url += `&centerId=${selectedCenter}`
      }
      getAppointmentsByPagination(url)
        .then((res: any) => {
          const { data, totalPages, totalElements } = res
          setPages(totalPages)
          setTotalPatientsCount(totalElements)
          setData(data)
        })
        .catch((err) => {
          console.log("err", err)
        })
    }
  }, [userRole, location, show, selectedCenter, pageSize, currPage, searchText?.trim(), centerFilter])

  useEffect(() => {
    if (rowPatientId) {
      getPatientDetail(rowPatientId)
        .then((res: any) => {
          updatePatientDetail(res)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }, [rowPatientId])


  //Made this Check for Bug no 16784, point no 4 and 5, This API was not required for Transfer Patient and patient List RMO
  useEffect(() => {
    if (appointmentId && pathName !== "/managePatients" && pathName !== "/patientList") {
      getAppointmentById(appointmentId)
        .then((res: any) => {
          setAppointmentDetails(res);
        })
        .catch((err: any) => {
          console.log(err?.message);
        });
    }
  }, [appointmentId, pathName]);

  useEffect(() => {
    if (appointmentDetails && patientDetail) {
      if (appointmentDetails?.consultantId) {
        getStaffType(appointmentDetails?.consultantId)
      } else if (patientDetail?.primaryConsultantId) {
        getStaffType(patientDetail?.primaryConsultantId)
      }
    }
  }, [appointmentDetails, patientDetail])

  const getStaffType = (id: any) => {
    if (id) {
      getManageStaffDetailsById(id)
        .then((res: any) => {
          setStaffDetails(res)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }

  function fetchPastAppointments(id: any) {
    getAppointmentsByQuery(
      `pastOrUpcoming=PAST&patientId=${id}&documentCompleteStatus=APPROVED`
    )
      .then((res) => updatePastAppointments(res?.reverse()))
      .catch((err) => {
        console.log("err", err)
      })
  }

  function handleChange(panel: any) {
    updateAccordion(panel !== accordion ? panel : false)
    if (panel !== accordion && data && data[panel]) {
      fetchPastAppointments(data[panel]?.id)
    }
  }

  function renderAccordion(
    eachPastAppointment: any,
    index: number
  ) {
    return (
      <>
        <div className={classes.accordion}>
          <div className={`${classes.accordionHeader} col-md-12 row p-0 m-0`}>
            <div className={`col-md-12 p-0`}>
              <div className={`${classes.accordionHeaderSpacing} d-flex`}>
                <div className="col-md-3 p-0">
                  <div className={classes.appContentTitle}>Patient ID</div>
                  <div className={classes.appContentValue}>
                    {eachPastAppointment?.mocId
                      ? eachPastAppointment?.mocId
                      : "-"}
                  </div>
                </div>
                <div className="col-md-2 p-0">
                  <div className={classes.appContentTitle}>Name</div>
                  <div className={classes.appContentValue}>
                    {eachPastAppointment?.name
                      ? eachPastAppointment?.name
                      : "-"}
                  </div>
                </div>
                <div className="col-md-1 p-0">
                  <div className={classes.appContentTitle}>Age</div>
                  <div className={`${classes.appContentValue}`}>
                    {eachPastAppointment?.age
                      ? calculateAge(eachPastAppointment?.dob)
                      : "-"}
                  </div>
                </div>
                <div className="col-md-2 p-0">
                  <div className={classes.appContentTitle}>Phone No</div>
                  <div className={`${classes.appContentValue}`}>
                    {eachPastAppointment?.phoneNumber
                      ? eachPastAppointment?.phoneNumber
                      : "-"}
                  </div>
                </div>
                <div className="col-md-2 p-0">
                  <div className={classes.appContentTitle}>Center</div>
                  <div className={`${classes.appContentValue}`}>
                    {eachPastAppointment?.centers[0]?.centerName
                      ? eachPastAppointment?.centers[0]?.centerName
                      : "-"}
                  </div>
                </div>
                <div className="col-md-2 p-0">
                  <div className={`${classes.pl30}`}>
                    <img
                      className={globalStyles.pointer}
                      src={
                        accordion === index
                          ? "../../../assets/images/chevronUpIcon.svg"
                          : "../../../assets/images/chevronDownIcon.svg"
                      }
                      alt={accordion === index ? "upArrow" : "downArrow"}
                      onClick={() => handleChange(index)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {accordion === index && (
          <div className={`${classes.accordionContent}`}>
            {pastAppointments?.length > 0 ? (
              <>
                {
                  pastAppointments?.map((each: any) => {
                    return (
                      <>
                        {renderAccordionContentRow(
                          eachPastAppointment,
                          each,
                        )}
                      </>
                    )
                  })
                }
              </>
            ) : (
              <div className={classes.noDataState}>No data available.</div>
            )}
          </div>
        )}
      </>
    )
  }

  function renderAccordionContentRow(
    patient: any,
    content: any
  ) {
    return (
      <div
        onClick={() => {
          setrowPatientId(patient?.id)
          setAppointmentId(content?.id)
          setShow(true)
        }}
        className="col-md-12 m-0 p-0 row"
      >
        <div className={`${classes.accordionRowContent} ${classes.btmBorder} col-md-12 m-0 row`}>
          <div
            className={`col-md-2 p-0 ${classes.appContentValue}`}
          >
            Type:
          </div>
          <div
            className={`col-md-2 p-0 ${classes.appContentValue}`}
          >
            {content?.appointmentType ? content?.appointmentType : "-"}
          </div>
          <div
            className={`col-md-2 p-0 ${classes.appContentValue}`}
          >
            Date:
          </div>
          <div
            className={`col-md-2 p-0 ${classes.appContentValue}`}
          >
            {content?.scheduleDate ? moment(content?.scheduleDate).format("DD-MM-YYYY") : "-"}
          </div>
          <div
            className={`col-md-2 p-0 ${classes.appContentValue}`}
          >
            Status:
          </div>
          <div
            className={`col-md-2 p-0 ${classes.appContentValue}`}
          >
            {content?.documentCompleteStatus}
          </div>
        </div>
      </div>
    )
  }

  const handleTransferPatient = (id: any) => {
    setPatientId(id)
  }

  const uploadHandler = (event: any, props: any) => {
    const rowData = props?.row?.original
    const fileObj = event.target.files
    let fileArr: any = []
    const fileList = Object.entries(fileObj).map(([key, f]) => f)
    fileList.forEach((file: any) => {
      let tempObj = {
        name: file?.name,
      }
      fileArr.push(tempObj)
    })
    const formData = new FormData()
    fileList.forEach((f: any) => {
      formData.append("files", f)
    })
    // upload file and get the url
    uploadSpecificFile(formData, false)
      .then((data: any) => {
        data.forEach((d: any, index: any) => {
          fileArr[index].blobUrl = d
        })
        if (rowData.mrdDocuments !== null && rowData.mrdDocuments.length > 0) {
          rowData.mrdDocuments = [...rowData?.mrdDocuments, ...fileArr]
        } else {
          rowData.mrdDocuments = [...fileArr]
        }
        delete rowData["patientName"]
        delete rowData["gender"]
        delete rowData["age"]
        delete rowData["primaryPhoneNumber"]
        delete rowData["email"]
        delete rowData["isVIP"]
        delete rowData["allottedBed"]
        delete rowData["invoiceId"]
        delete rowData["isEditable"]
        delete rowData["dob"]
        delete rowData["medicalRecordsId"]
        delete rowData["bedIsVacant"]
        delete rowData["bedMadeVacantAt"]
        delete rowData["mocAppointmentId"]
        delete rowData["serviceName"]
        delete rowData["finalInvoiceAmount"]

        updateAppointment(rowData)
          .then((res: any) => {
            setIsUploaded(true)
          })
          .catch((err: any) => setIsUploadError(true))
      })
      .catch((err: any) => {
        const errCode = err?.response?.data?.code;
        if (errCode === 'MaxUploadSizeExceededException') {
          setFileSizeError(true)
        }
        console.log(err, "err in uploading file")
      })
  }

  const handleSearch = (e: any) => {
    let url = ""
    if (e?.length) {
      url = `?page=${currPage}&pageSize=${pageSize}&sortBy=createdAt&searchText=${e}`
    } else {
      url = `?page=${currPage}&pageSize=${pageSize}&sortBy=createdAt`
    }
    getallPatientDetail(url)
      .then((res) => {
        const { data, totalPages, totalCount } = res
        setPages(totalPages)
        setTotalPatientsCount(totalCount)
        const response = data?.filter(
          (each: any) => !each?.isDeleted || each?.isDeleted === false
        )
        setData(response)
      })
      .catch((err) => {
        console.log("err", err)
      })
  }

  const redirectTo = (id: any) => {
    if (id) {
      getLatestAppointmentDetails(id)
        .then((res: any) => {
          history.push(`/patientDiagnosis/${id}?appointmentId=${res?.id}`)
        })
        .catch((err: any) => {
          console.log(err?.message)
          setNoAppointmentsError(true)
        })
    }
  }

  return (
    <div className="patient-directory-wrapper">
      {
        isUploaded ? (
          <Toast
            textMessage="Uploaded successfully"
            type="success"
            onCloseText={"Close"}
            onClose={() => {
              setIsUploaded(false)
            }}
          ></Toast>
        ) : isApproved ? (
          <Toast
            textMessage="Approved successfully"
            type="success"
            onCloseText={"Close"}
            onClose={() => {
              setIsApproved(false)
            }}
          ></Toast>
        ) : isRejected ? (
          <Toast
            textMessage="Rejected successfully"
            type="success"
            onCloseText={"Close"}
            onClose={() => {
              setIsRejected(false)
            }}
          ></Toast>
        ) : isUploadError ? (
          <Toast
            textMessage="Uplaod Failed"
            type="error"
            onCloseText={"Close"}
            onClose={() => {
              setIsUploadError(false)
            }}
          ></Toast>
        ) : fileSizeError ? (
          <Toast
            textMessage="File Size should be less than 1 MB"
            type="warning"
            onCloseText={"Close"}
            onClose={() => {
              setFileSizeError(false)
            }}
          ></Toast>
        ) : noAppointmentsError ? (
          <Toast
            textMessage={"No appointment history found"}
            type={"error"}
            onCloseText="Close"
            onClickText={null}
            onClose={() => {
              setNoAppointmentsError(false)
            }}
          ></Toast>
        ) : null
      }
      <div className="heading-directory">
        {pathName === "/managePatients"
          ?
          <div
            className="approval-back-image"
            onClick={() => {
              history.push("/home")
            }}
          >
            <img
              src={"../../../assets/images/back-icon.svg"}
              height={"60px"}
              width={"60px"}
              alt="back button"
              className="back_button"

            />
            <span className="manage-patient-heading">Manage Patient</span>
          </div>

          : pathName === "/mrd" ? "Appointments List" :
            "Patient Directory"}
      </div>
      {
        (pathName === "/managePatients" && userRole !== MocUserRole.CENTER_ADMIN) ? (
          <div className="col-md-3 col-lg-3">
            <div>
              <label className="location-label">Location : </label>
            </div>
            <Select
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  border: "1px solid #ccd0e7",
                  borderRadius: "10px"
                })
              }}
              options={centerOptions}
              onChange={(option: any) => {
                setCenterFilter(option?.value)
              }}
              placeholder="Select Location..."
              value={centerOptions?.filter(({ value }: any) => value === centerFilter)}
            />
          </div>
        ) : null
      }
      <div className="directory-content">
        <div className="count">Total Patients: &nbsp; {totalPatientsCount ? totalPatientsCount : data?.length}</div>
      </div>
      {
        userRole === MocUserRole.MRD && pathName === "/patientList" ? (
          <div className="table-container">
            <input
              type="text"
              className="inputGlobalSearch"
              onChange={(e) => {
                handleSearch(e.target.value)
              }}
              placeholder="Search"
            />
            <img src="../../assets/images/searchIcon.svg" alt="" style={{ marginLeft: "-50px", width: "26px", height: "26px" }}></img>
            <div className={classes.appointments}>
              <div className={`${classes.card} ${classes.pt21}`}>
                <>
                  {data && data?.length > 0 ? (
                    data?.map((each: any, index: any) =>
                      renderAccordion(each, index)
                      // <div></div>
                    )
                  ) : (
                    <div className={`${classes.noDataState}`}>
                      No data available.
                    </div>
                  )}
                  {
                    data && data?.length > 0 ? (
                      <div
                        style={{ marginTop: "20px" }} className="pagination-footer"
                      >
                        <button
                          className="pagination-button"
                          onClick={() => {
                            setCurrPage(0);
                          }}
                          disabled={currPage === 0}
                        >
                          {"First"}
                        </button>
                        <button
                          className="pagination-button"
                          onClick={() => {
                            setCurrPage(currPage - 1);
                          }}
                          disabled={currPage === 0}
                        >
                          {"Previous"}
                        </button>
                        <span className="pagination-text">
                          Page{" "}
                          <strong>
                            {currPage + 1} of {pages}
                          </strong>
                        </span>
                        <button
                          className="pagination-button"
                          onClick={() => {
                            setCurrPage(currPage + 1);
                          }}
                          disabled={currPage === pages - 1}
                        >
                          {"Next"}
                        </button>
                        <button
                          className="pagination-button"
                          onClick={() => {
                            setCurrPage(pages - 1);
                          }}
                          disabled={currPage === pages - 1}
                        >
                          {"Last"}
                        </button>
                        <select
                          className="pagination-select"
                          value={pageSize}
                          onChange={(e) => {
                            setPageSize(Number(e.target.value));
                            setCurrPage(0);
                          }}
                        >
                          {[10, 15, 20, 25, 50].map((pageSize) => (
                            <option key={pageSize} value={pageSize}>
                              {pageSize}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : null
                  }
                </>
              </div>
            </div>
          </div>
        ) : (
          <Table
            data={data}
            columns={columns}
            globalFilterRequired={true}
            onColClick={(colValue: any, id: any, patientId: any, rowData: any) => {
              setAppointmentId(id)
              if (userRole.toLowerCase() === MocUserRole.MRD.toLowerCase() && location?.pathname === "/mrd") {
                if (colValue === "documentCompleteStatus") {
                  //Completeness
                } else if (colValue === "upload") {
                  //Upload
                } else {
                  setrowPatientId(patientId)
                  setShow(true)
                }
              }
              else {
                if (colValue?.toLowerCase() === "transfer patient") {
                  if (rowData?.survivalStatus != "Deceased") {
                    handleTransferPatient(id)
                    setViewTransferPatient(true)
                  }
                } else {
                  pathName === "/managePatients"
                    ?
                    history.push({
                      pathname: `/managePatients/${id}`,
                      state: {
                        previousState: "Manage-Patient",
                        centerId: centerFilter
                      }
                    })
                    :
                    (userRole !== MocUserRole.FRONT_DESK) ?
                      redirectTo(id) : history.push(`/patientList/${id}`)
                }
              }
            }}
            onRowClick={(id: any) => { }}
            enablePagination={true}
            totalPages={pages}
            currPage={currPage}
            setCurrPage={setCurrPage}
            setPageSizeVal={setPageSize}
            pageSizeVal={pageSize}
            searchText={searchText}
            setSearchText={setSearchText}
          />
        )
      }
      <div>
        {viewTransferPatient === true && (
          <ViewTransferPatient
            show={viewTransferPatient}
            closePrintModal={(close: boolean) => {
              setViewTransferPatient(close)
              window.location.reload()
            }
            }
            id={patientId}
          />
        )}
      </div>
      {
        show && (
          patientDetail && (
            <Forms
              patientInfo={patientDetail}
              show={show}
              setShow={setShow}
              appointmentId={appointmentId}
              appointment={appointmentDetails}
              staffInfo={staffDetails}
            />
          )
        )
      }
    </div >
  )
}

export default PatientDirectory
